import {css} from "lit-element/lit-element.js";
export default css`
:root {
  --text-bg: hsl(0, 0%, 97%);
  --gray-border: hsla(0, 0%, 0%, 0.1);
  --gray: rgba(0, 0, 0, 0.6);
  --border-radius: 5px;
  --orange: hsl(24, 100%, 50%);
  --distill-blue: hsl(200, 50%, 25%);
  --blue: #337699;
  --green: #3db867;
  --text-fg: rgb(15, 15, 15);
  --text-red: rgb(220, 0, 0);
  --bar-col: rgb(171, 199, 227);
  --link-col: rgb(0, 0, 238);
  --placeholder-col: rgb(166, 166, 166);
  --note-bg: #e1f5fe;
  --note-fg: #1a6ebb;
  --warn-bg: #ffe1aa;
  --warn-fg: #a16800;
  --error-bg: #850000;
  --error-fg: white;
}
@media (prefers-color-scheme: dark) {
  :root {
    --text-bg: rgb(56, 56, 56);
    --text-fg: rgb(213, 213, 213);
    --bar-col: rgb(20, 109, 163);
    --link-col: rgb(66, 165, 245);
    --note-fg: rgb(121 157 190);
    --note-bg: rgb(2 59 85);
    --warn-bg: #784e00;
    --warn-fg: #edbe68;
  }
}

.message {
  padding: 0.1rem 0.5rem;
  margin-bottom: 1rem;
}

.warning {
  background: var(--warn-bg);
  color: var(--warn-fg);
}

.error {
  background: var(--error-bg);
  color: var(--error-fg);
}

.info {
  background: var(--note-bg);
  color: var(--note-fg);
}

.close {
  float: right;
  cursor: pointer;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
